import SingleListProduct from "./SingleListProduct";

export default SingleListProduct;
